export default function googleReview({main, elm, state, publish}) {
	main(_ => {
		const {photos} = state.get();

		if (photos.length) {
			elm.addEventListener('click', open);
		}
	});

	const open = function () {
		const review = state.get();

		publish('review:open', review);
	};
};

export const model = {};
